import { Badge, Box, Drawer, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    width: '100%',
    maxWidth: 520,
    padding: '24px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const DrawerHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  '& span': { fontSize: '24px' },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: theme.palette.secondary.main,
  marginTop: '24px',
  marginBottom: '12px',
}));

export const CommentCard = styled(Box)(() => ({
  borderLeft: '3px solid #E3E8EF',
  paddingLeft: '12px',
  marginBottom: '20px',
}));

export const CommentMeta = styled(Typography)(() => ({
  color: '#595959',
  fontSize: '13px',
  marginBottom: '4px',
}));

export const NoticeTag = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: '13px',
  fontWeight: 600,
}));

export const EmptyState = styled(Typography)(() => ({
  color: '#8A8A8A',
  fontSize: '14px',
  marginBottom: '8px',
}));

// A célula fica dentro de uma linha clicável: o contador precisa de área de
// clique própria sem disparar a navegação da linha.
export const CommentsCellButton = styled(IconButton)(({ theme }) => ({
  padding: '4px',
  '& span': {
    fontSize: '22px',
    color: theme.palette.secondary.main,
  },
  '&.Mui-disabled span': {
    color: '#B9BEC7',
  },
}));

export const CommentsBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    fontSize: '11px',
    height: '18px',
    minWidth: '18px',
  },
}));
